export default {"src":"/_next/static/media/FanslyInverted.d4b9d0af.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};